import { TimelineMax } from 'gsap/TweenMax';
import { createElement as $$ } from './helpers';

// ***************************************
// Menu

const menuTimeline = new TimelineMax();

// Build the large menu.
export function menuBuilder(container, sections) {
    // Return the array of links
    const links = [];

    // Create some elements
    const div = $$('div', 'container-fluid');
    const row = $$('div', 'row');
    const dv1 = $$('div', 'col-lg-4 offset-lg-2 col-xl-3 offset-xl-3 menu--focus');
    const dv2 = $$('div', 'col-lg-4 col-xl-3 menu--focus');
    div.appendChild(row);
    row.appendChild(dv1);
    row.appendChild(dv2);

    // For each strip, create a menu item. Uses the links array length to determine
    // the 1/2 way point and puts items in the appropirate column (1/2 and 1/2).
    const createStripLink = ({ stripId, stripTitle }) => {
        const link = $$('a');

        link.onclick = (event) => menuCloser(event, links);
        link.className = 'menu-link';
        link.innerHTML = `<span>${stripTitle}</span>`;
        link.href = `#strip-${stripId}`;
        link.id = `strip-menu-${stripId}`;

        if (links.length < Math.round(sections.length / 2)) {
            dv1.appendChild(link);
        } else {
            dv2.appendChild(link);
        }

        links.push(link);
    };

    // Only process strips with the 'animated' data property.
    [...sections]
        .filter(({ dataset }) => dataset.strip == 'animated')
        .map(({ dataset }) => createStripLink(dataset));

    // Add to the container.
    if (container.length) {
        container[0].appendChild(div);
    }

    return links;
}

// Close the large menu. This is basically a reverse of the menuOpener function.

export function menuCloser(event, menuItems) {
    if (menuTimeline.isActive() && document.body.classList.contains('menu--active')) {
        return;
    }

    document.activeElement.blur();

    menuTimeline
        .staggerTo(menuItems.slice().reverse(), 0.3, { ease: Power3.easeOut, opacity: 0, y: 10 }, 0.03)
        .to(document.querySelectorAll('.strip-navigation')[0], 0.4, { ease: Expo.easeOut, opacity: 0 })
        .addCallback((event) => {
            document.querySelectorAll('.strip-navigation')[0].style.opacity = 1;
            document.body.classList.remove('menu--active');
        });
}

// Open the large menu.
export function menuOpener(event, menuItems) {
    if (menuTimeline.isActive() && !document.body.classList.contains('menu--active')) {
        return;
    }

    const container = document.querySelectorAll('.strip-navigation')[0];
    document.body.classList.add('menu--active');

    // Focus the first element
    document.getElementById('strip-menu-1').focus();

    menuTimeline
        .set(menuItems, { opacity: 0, y: 20 })
        .set(container, { opacity: 0 })
        .to(container, 0.6, { ease: Expo.easeOut, opacity: 1 })
        .staggerTo(menuItems, 0.6, { ease: Power3.easeOut, opacity: 0.9, y: 0 }, 0.03);
}
